import styles from './index.module.scss';
import { TooltipContentProps } from './interface';

const TooltipContent = (props: TooltipContentProps) => {
  const { percentCompletedCases, completedCasesPercent } = props;
  return (
    <div className={styles.tooltipContentContainer}>
      <div className={styles.labelText}>Cases Completed</div>
      <div className={styles.percentContainer}>
        <span className={styles.paidCount}>{percentCompletedCases.paid}</span>
        {` / ${percentCompletedCases.total} = ${completedCasesPercent}%`}
      </div>
    </div>
  );
};

export default TooltipContent;
